
import React from "react";
import { TabsContent } from "@/components/ui/tabs";
import ProviderTable from "@/components/admin/ProviderTable";
import { StrategyProvider, UserInfo } from "@/types/strategy-types";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ProvidersTabProps {
  providers: StrategyProvider[];
  users: UserInfo[];
  createProvider: (provider: Omit<StrategyProvider, 'id' | 'created_at' | 'updated_at'>) => Promise<void>;
  updateProvider: (id: string, provider: Partial<StrategyProvider>) => Promise<void>;
  deleteProvider: (id: string) => Promise<void>;
  toggleProviderActive: (providerId: string, isActive: boolean) => Promise<void>;
  assignUserToProvider: (providerId: string, userId: string) => Promise<void>;
  removeUserFromProvider: (providerId: string, userId: string) => Promise<void>;
}

const ProvidersTab = ({
  providers,
  users,
  updateProvider,
  deleteProvider,
  toggleProviderActive,
  assignUserToProvider,
  removeUserFromProvider
}: ProvidersTabProps) => {
  return (
    <TabsContent value="providers" className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold">Providers</h2>
        <Link to="/admin/provider/new">
          <Button>
            <Plus className="h-4 w-4 mr-2" />
            Add Provider with Wizard
          </Button>
        </Link>
      </div>
      
      <ProviderTable
        providers={providers}
        users={users}
        onCreateProvider={() => Promise.resolve()} // Fixed: Return a Promise instead of void
        onUpdateProvider={updateProvider}
        onDeleteProvider={deleteProvider}
        onToggleActive={toggleProviderActive}
        onAssignUser={assignUserToProvider}
        onRemoveUser={removeUserFromProvider}
      />
    </TabsContent>
  );
};

export default ProvidersTab;
